import HttpService from "./htttp.service";

class ProductRequirementsService {
  // ProductRequirementsEndpoint = process.env.API_URL;

  getProductRequirements = async () => {
    const getProductRequirements = "dash/product_requirements";
    return await HttpService.get(getProductRequirements);
  };

  getSingleProductRequirements = async (id) => {
    const getSingleProductRequirements = `dash/product_requirements/${id}`;
    return await HttpService.get(getSingleProductRequirements);
  };

  createProductRequirements = async (payload) => {
    const createProductRequirements = "dash/product_requirements/new";
    return await HttpService.post(createProductRequirements, payload);
  };

  editProductRequirements = async (id, payload) => {
    const editProductRequirements = `dash/product_requirements/${id}`;
    return await HttpService.put(editProductRequirements, payload);
  };

  deleteProductRequirements = async (id, payload) => {
    const deleteProductRequirements = `dash/product_requirements/${id}`;
    return await HttpService.delete(deleteProductRequirements, payload);
  };
}

export default new ProductRequirementsService();
